<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'


/* ========================
   Props Definition
   ======================== */
const props = defineProps<{
  userShow?: boolean
  placeShow?: boolean
  classShow?: string
}>()


</script>

<template>
  <div :class="userShow ? 'col-md-12' : (props.classShow ? props.classShow : 'col-md-6')">
    <div class="skeleton">
        <div class="skeleton-wrapper">
            <div class="skeleton-wrapper-inner">
                <div class="skeleton-wrapper-body">
                    <div class="skeleton-avatar"></div>
                    <div class="skeleton-author"></div>
                    <div class="skeleton-label"></div>
                    <div class="skeleton-stars"></div>
                    <div class="skeleton-content-1"></div>
                    <div class="skeleton-content-2"></div>
                    <div class="skeleton-content-3"></div>
                    <div class="skeleton-content-4"></div>
                    <div class="skeleton-content-4-1"></div>
                    <div class="skeleton-content-4-2"></div>
                    <div class="skeleton-content-4-3"></div>

                </div>
            </div>
        </div>
    </div>
  </div>

</template>
<style>

.skeleton-wrapper {
            background: #fff;
            border: 1px solid;
            border-color: #f0f2f5;
            border-radius: 18px;
            -webkit-border-radius: 18px;
            margin: 10px 0;
            box-shadow: 0 1px 2px 0 rgba(237, 237, 237, 0.5);
        }

        .skeleton-wrapper-inner {
            height: 280px;
            padding: 15px;
            position: relative;
        }

        .skeleton-wrapper-body div {
            -webkit-animation-duration: 1s;
            -webkit-animation-fill-mode: forwards;
            -webkit-animation-iteration-count: infinite;
            -webkit-animation-name: placeholderSkeleton;
            -webkit-animation-timing-function: linear;
            background: #f5f7f9;
            background-image: -webkit-gradient(linear, left center, right center, from(#f5f7f9), color-stop(.2, #edeef1), color-stop(.4, #f5f7f9), to(#f5f7f9));
            background-image: -webkit-linear-gradient(left, #f5f7f9 0%, #edeef1 20%, #f5f7f9 40%, #f5f7f9 100%);
            background-repeat: no-repeat;
            background-size: 800px 104px;
            height: 104px;
            position: relative;
        }

        .skeleton-wrapper-body {
            -webkit-animation-name: skeletonAnimate;
            background-image: -webkit-gradient(linear, center top, center bottom, from(deg), color-stop(0, red), color-stop(.15, orange), color-stop(.3, yellow), color-stop(.45, green), color-stop(.6, blue), color-stop(.75, indigo), color-stop(.8, violet), to(red));
            background-image: -webkit-linear-gradient(135deg, red 0%, orange 15%, yellow 30%, green 45%, blue 60%, indigo 75%, violet 80%, red 100%);
            background-repeat: repeat;
            background-size: 50% auto;
        }

        .skeleton-wrapper-body div {
            position: absolute;
            right: 15px;
            left: 15px;
            top: 15px;
        }

        div.skeleton-avatar {
          height: 40px;
          width: 40px;
          border-radius: 50px;
          right: 15px;
          left: auto;
        }

        div.skeleton-author {
            top: 20px;
            height: 20px;
            right: 70px;
            width: 150px;
        }

        div.skeleton-stars {
            top: 73px;
            right: 15px;
            height: 15px;
            max-width: 132px;
        }

        div.skeleton-label {
            right: 70px;
            top: 50px;
            height: 10px;
            width: 100px;
        }

        div.skeleton-content-1,
        div.skeleton-content-2,
        div.skeleton-content-3 {
            right: 15px;
            right: 15px;
            height: 10px;
        }

        div.skeleton-content-1 {
            top: 108px;
        }

        div.skeleton-content-2 {
            top: 130px;
        }

        div.skeleton-content-3 {
            top: 150px;
        }

        div.skeleton-content-4 {
            top: 175px;
            height: 80px;
            width: 80px;
            border-radius: 18px;
        }
        div.skeleton-content-4-1 {
            top: 175px;
            height: 80px;
            width: 80px;
            right: calc(80px + 25px);
            border-radius: 18px;
        }

        div.skeleton-content-4-2 {
            top: 175px;
            height: 80px;
            width: 80px;
            right: calc(160px + 35px);
            border-radius: 18px;
        }

        div.skeleton-content-4-3 {
            top: 175px;
            height: 80px;
            width: 80px;
            right: calc(240px + 45px);
            border-radius: 18px;
        }

        div.skeleton-content-4-4 {
            top: 175px;
            height: 80px;
            width: 80px;
            right: calc(320px + 65px);
            border-radius: 18px;
        }

        @media(max-width: 767px) {
           
            div.skeleton-content-4-2,
            div.skeleton-content-4-3,
            div.skeleton-content-4-4 {
              display: none;
            }
        }

       
        @-webkit-keyframes placeholderSkeleton {
            0% {
                background-position: -468px 0;
            }

            100% {
                background-position: 468px 0;
            }
        }

        @-webkit-keyframes skeletonAnimate {
            from {
                background-position: top left;
            }

            to {
                background-position: top right;
            }
        }
</style>